import React from 'react';
import { Component } from '@poa/core';

class CalendarsTableSidebar extends React.Component {
  static defaultProps = {
    innerRef: () => {
    }
  };

  render() {
    const { rates } = this.props;

    return (
      <table>
        <tbody 
        ref={node => this.props.innerRef(node)} 
        onScroll={this.props.onScroll}
        >
        {rates}
        </tbody>
      </table>
    );
  }
}

export default Component({ namespaces: ['calendar2'] })(CalendarsTableSidebar);
